// extracted by mini-css-extract-plugin
export default {"message_form_wrapper":"MessageForm_message_form_wrapper__avhMw","emoji_icon_button":"MessageForm_emoji_icon_button__Vck5Z","emoji_wrapper":"MessageForm_emoji_wrapper__7JlUF"};